import type { FC } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { HelpImage } from '@pp/core/src/components/help/utils/HelpImage';
import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import cashier from '../../../../assets/helpAssets/cashier.png';
import QuickBets from '../../../../assets/helpAssets/QuickBets.png';

import styles from './CrashGameHelp.module.css';

export const CrashHelpChapterPlacingBets: FC = () => {
  const tableName = useConfigSlice.tableName() ?? '';
  const tableBetLimits = useConfigSlice.tableBetLimits();
  if (!tableName || !tableBetLimits) return null;
  return (
    <div>
      <p>
        <HelpText tk="placingBetsHF.twoBets" />
      </p>
      <p>
        <HelpText tk="placingBetsHF.gameName" markdown />
      </p>
      <p>
        <b className={styles.tbNameLimits}>
          <L10nText tk={tableName} />
          &nbsp;
          <span>
            <CurrencyConnected value={tableBetLimits.min} avoidTrailingZero />
            {' - '}
            <CurrencyConnected value={tableBetLimits.max} avoidTrailingZero />
          </span>
        </b>
      </p>
      <p>
        <HelpText tk="placingBetsHF.gameIndicator" markdown />
      </p>
      <p>
        <HelpText tk="placingBetsHF.waitNextGame" />
      </p>
      <br></br>
      <div className={styles.nxtGameCaps}>
        <L10nText tk="WAITFORNEXTGAME_CAPS" />
      </div>
      <p>
        <HelpText tk="placingBetsHF.nextGame" />
      </p>
      <br></br>
      <div className={styles.nxtGameIn}>
        <L10nText tk="NXT_GAME_CAPS" />
        &nbsp;
        <span className={styles.nxtGameCapsSec}>5s</span>
      </div>
      <p>
        <HelpText tk="placingBetsHF.betsClosed" />
      </p>
      <p>
        <HelpText tk="placingBetsHF.quickBets" markdown />
      </p>
      <HelpImage url={QuickBets} alt="Quickbets" />
      <p>
        <HelpText tk="placingBetsHF.balanceIndicator" markdown />
      </p>
      <p>
        <HelpText tk="placingBetsHF.refresh" />
      </p>
      <p>
        <HelpText tk="placingBetsHF.cashierButton" markdown />
      </p>
      <HelpImage url={cashier} alt="cashier" />
      <p>
        <HelpText tk="placingBetsHF.betIndicator" markdown />
      </p>
      <p>
        <HelpText tk="placingBetsHF.gameID" markdown />
      </p>
      <p>
        <HelpText tk="placingBetsHF.gameIDReference" />
      </p>
    </div>
  );
};
